<i18n>
{
  "th": {
    "datePicker": {
      "placeholder": "เลือกวันที่",
      "allDate": "วว/ดด/ปป"
    }
  }
}
</i18n>
<template>
  <div class="snt-date-picker">
    <v-menu
      :close-on-content-click="false"
      offset-y>
      <template #activator="{ on, attrs }">
        <v-text-field
          :value="dateDisplay"
          v-bind="attrs"
          :placeholder="$t('datePicker.placeholder')"
          :height="height"
          class="input-date"
          append-icon="$snt_calendar_outline"
          outlined
          readonly
          dense
          hide-details
          v-on="on">
          <template #append>
            <div class="d-flex gap-2">
              <v-icon
                v-if="clearable && !!value"
                small
                @click="$emit('input', null)">
                mdi-close
              </v-icon>
              <v-icon
                color="secondary"
                @click="setMenu(true)">
                $snt_calendar_outline
              </v-icon>
            </div>
          </template>
        </v-text-field>
      </template>
      <v-date-picker
        :value="value"
        :title-date-format="titleDateFormat"
        :header-date-format="headerDateFormat"
        :month-format="monthFormat"
        :year-format="yearFormat"
        color="primary"
        @input="changeDate($event)" />
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Array],
      default: ''
    },
    height: {
      type: [String, Number],
      default: '40px'
    },
    clearable: Boolean
  },
  computed: {
    dateDisplay () {
      if (!this.value) return this.$t('datePicker.allDate')
      const startDate = this.$dayjs(this.value).format('DD/MM/YY')
      return `${startDate}`
    }
  },
  methods: {
    titleDateFormat (value) {
      if (!value) return this.$t('datePicker.allDate')
      const startDate = this.$dayjs(value).format('DD/MM/YY')
      return `${startDate}`
    },
    headerDateFormat (value) {
      const d = new Date(value)
      const year = d.getFullYear()
      const month = d.getMonth()
      const monthItems = [
        'มกราคม',
        'กุมภาพันธ์',
        'มีนาคม',
        'เมษายน',
        'พฤษภาคม',
        'มิถุนายน',
        'กรกฎาคม',
        'สิงหาคม',
        'กันยายน',
        'ตุลาคม',
        'พฤศจิกายน',
        'ธันวาคม'
      ]
      return `${monthItems[month] || month} ${year}`
    },
    monthFormat (value) {
      const d = new Date(value)
      const month = d.getMonth()
      const monthItems = [
        'ม.ค.',
        'ก.พ.',
        'มี.ค.',
        'เม.ย.',
        'พ.ค.',
        'มิ.ย.',
        'ก.ค.',
        'ส.ค.',
        'ก.ย.',
        'ต.ค.',
        'พ.ย.',
        'ธ.ค.'
      ]
      return monthItems[month] || month
    },
    yearFormat (value) {
      return value
    },
    changeDate (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
